import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Pagination from "react-js-pagination";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  fetchReviewerList,
  searchReviewer,
  openAddReviewer,
} from "ProposalAction";
import { fetchUsersCategory } from "DashboardUserAction";
import { fetchEventDetails } from "DashboardUserAction";
import { itemCount, DOMAIN_NAME, screenHeightLeftFromTop } from "Constants";
import ReviewerItem from "./reviewer-item-list";
import AddReviewer from "../dashboard/add-reviewer";
import ChangePassword from "./change-password.js";
import LocaleStrings from "Languages";

class Reviewer extends Component {
  constructor(props) {
    super(props);
    this.state = { pageNumber: 1, search: "", alphabets: [], copied: false };
  }

  componentDidMount() {
    this.props.fetchUsersCategory(this.props.session);
    this.props.fetchReviewerList(this.props.session);
    this.props.fetchEventDetails(this.props.session);
  }

  renderReviewerList = () => {
    return _.map(this.props.reviewerList.data, (reviewer) => {
      //if(reviewer.proposal_reviewer_by_reviewerid && reviewer.proposal_reviewer_by_reviewerid.length >0){
      return <ReviewerItem key={reviewer.appuserid} reviewer={reviewer} />;
      //}
    });
  };

  paginationCallback = (pageNumber) => {
    this.props.fetchReviewerList(
      this.props.session,
      pageNumber,
      0,
      (response) => {}
    );
    this.setState({ ...this.state, pageNumber });
  };

  userAdditionCallback = () => {
    this.paginationCallback(this.state.pageNumber);
  };

  onSearchUser = (event) => {
    var search = event.target.value;
    let pageNumber = 1;
    if (search == "") {
      this.props.fetchReviewerList(
        this.props.session,
        pageNumber,
        0,
        (response) => {}
      );
    } else {
      this.props.searchReviewer(
        this.props.session,
        search,
        pageNumber,
        0,
        (response) => {}
      );
    }
    this.setState({ search, pageNumber });
  };

  copyUrl = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  addReviewer = () => {
    this.props.openAddReviewer(true, "");
  };

  render() {
    var { deviceSize, reviewerList, eventDetails, showChangePasswordReviewer } =
      this.props;

    let style = {
      paddingTop: 25,
      paddingLeft: 15,
    };

    let options = [];
    options.push(<option value="">{LocaleStrings.proposal_sort}</option>);
    options.push(
      <option key="name" value="name">
        Name
      </option>
    );
    options.push(
      <option key="email" value="email">
        Email
      </option>
    );

    let seocode =
      eventDetails && eventDetails.seocode
        ? eventDetails.seocode
        : "not-found-seocode";
    var reviewerLoginUrl = `https://${seocode}.${DOMAIN_NAME}/t/reviewer/`;

    return (
      <div className="panel noborder-panel">
        {showChangePasswordReviewer.showModal ? <ChangePassword /> : ""}

        <div
          className="content-header-bar"
          style={{
            borderBottom: "2px solid #e6edf3",
          }}
        >
          <div className="vertical-align-center">
            <div>
              <div className="tickets-heading">
                {LocaleStrings.reviewer_heading}
              </div>
              <div className="custom-text2-secondary-normal subtext-tabhidden">
                {LocaleStrings.reviewer_subheading}
              </div>
            </div>
          </div>

          <ul className="header-buttons">
            {/* <li>
                <select
                  // className="form-control"
                  onChange={(e) => this.handleProposal(e)}
                  className="form-control selectbox dropdown-height-border"
                >
                  {options}
                </select>
              </li> */}
            <li>
              <input
                className="form-control mapsearch"
                placeholder={LocaleStrings.button_search}
                type="text"
                value={this.state.search}
                onChange={this.onSearchUser}
              />
            </li>
            <li>
              <button
                type="button"
                className="btn btn-custom-blue"
                onClick={this.addReviewer}
              >
                <i className="glyphicon glyphicon-plus i-custom-ms"></i>
                {LocaleStrings.proposal_wizard_add_reviewer_button}
              </button>
              {this.props.addReviewerModal.showModal ? (
                <AddReviewer
                  finishOperationsCallback={this.userAdditionCallback}
                />
              ) : (
                ""
              )}
            </li>
          </ul>
        </div>

        <div className="reviewer-header-bar">
          <div className="col-xs-12">
            <div style={{ padding: 10 }}>
              <div className="promote-para">Reviewer Login</div>

              <div className="row" style={{ overflowX: "auto" }}>
                <div className="col-sm-4">
                  <div className="copy-ticket-page">
                    <div className="ticket-url">{reviewerLoginUrl}</div>
                    <CopyToClipboard
                      text={reviewerLoginUrl}
                      onCopy={this.copyUrl}
                    >
                      <div className="url-copy">
                        <i className="fa fa-files-o" aria-hidden="true"></i>
                        &nbsp;{LocaleStrings.button_copy}
                      </div>
                    </CopyToClipboard>
                  </div>
                  {this.state.copied ? (
                    <span style={{ color: "black", float: "right" }}>
                      {LocaleStrings.copied}.
                    </span>
                  ) : null}
                </div>
                <div className="col-sm-2">
                  <a
                    href={reviewerLoginUrl}
                    target="blank"
                    className="btn btn-lg btn-primary"
                    style={{ padding: "6px 20px" }}
                  >
                    <span aria-hidden="true">{LocaleStrings.button_visit}</span>
                  </a>
                </div>
              </div>
              {/* <h4 className="heading-para">{form_name}</h4> */}
            </div>
          </div>
        </div>

        <div
          className="panel-body scrollable-content"
          style={{
            height: deviceSize.height - (screenHeightLeftFromTop + 100),
          }}
        >
          {reviewerList && reviewerList.data && reviewerList.data.length > 0 ? (
            <div className="sponsor-table">
              <table className="table">
                <thead>
                  <tr>
                    <th>{LocaleStrings.proposal_reviewer_name}</th>
                    <th>{LocaleStrings.proposal_reviewer_email}</th>
                    <th>{LocaleStrings.proposal_reviewer_action}</th>
                  </tr>
                </thead>
                <tbody style={{ background: "#fff" }}>
                  {this.renderReviewerList()}
                </tbody>
              </table>
              <Pagination
                activePage={this.state.pageNumber}
                itemsCountPerPage={itemCount}
                totalItemsCount={this.props.reviewerList.count}
                pageRangeDisplayed={10}
                onChange={this.paginationCallback}
                style={{ float: "right" }}
              />
            </div>
          ) : this.state.search != "" ? (
            <div className="no-content-container">
              <div className="no-content-message">
                {LocaleStrings.proposal_text_no_reviewer_found}
              </div>
            </div>
          ) : (
            <div className="no-content-container">
              <div className="no-content-message">
                {LocaleStrings.proposal_text_no_reviewer}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log('state.SettingData :- ', state.SettingData);
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    reviewerList: state.appUserreviewerList,
    eventDetails: state.userEventDetails,
    addReviewerModal: state.addReviewerModal,
    showChangePasswordReviewer: state.showChangePasswordReviewer,
  };
}

export default connect(mapStateToProps, {
  fetchReviewerList,
  fetchUsersCategory,
  searchReviewer,
  fetchEventDetails,
  openAddReviewer,
})(Reviewer);
